import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export const withAuth = WrappedComponent => {
  class HOC extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }
  return connect(mapStateToProps)(HOC);
};

export default withAuth;
